module.exports = __webpack_public_path__ + "media/components/country-flag/static/ni-998475862bd5ce51dc3ef6cdcd2c48e4.svg";